import http from "./HttpService";

const BASE_SERVICE_URL = "customer-service";

export default {
  getCities(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/cities",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getProvinces(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/customer/provinces",
          request.header,
          request.payload
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  saveBillingInfo(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/billing-info/save",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getCustomerToken(request) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/chat-customer/token`,
        request.param,
        request.header
      )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  }
};
